import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { Book } from "@/data/books";

interface DbBook {
  id: string;
  title: string;
  author: string;
  hook: string;
  tropes: string[];
  mood: string[];
  cravings: string[];
  spice_level: number;
  emotional_intensity: string;
  trigger_warnings: string[] | null;
  cover_color: string;
  cover_image_url: string | null;
  featured: boolean;
  read_url: string | null;
  ebook_affiliate_link?: string | null;
  physical_book_affiliate_link?: string | null;
  audiobook_affiliate_link?: string | null;
  has_audiobook?: boolean | null;
  subgenre?: string[] | null;
  representation?: string[] | null;
  representation_custom?: string | null;
  series_type?: string | null;
  reading_experience?: string | null;
  created_at?: string;
}

const mapBook = (b: DbBook): Book => ({
  id: b.id,
  title: b.title,
  author: b.author,
  hook: b.hook,
  tropes: b.tropes,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mood: b.mood as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cravings: b.cravings as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  spiceLevel: b.spice_level as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emotionalIntensity: b.emotional_intensity as any,
  triggerWarnings: b.trigger_warnings ?? undefined,
  coverColor: b.cover_color,
  coverImageUrl: b.cover_image_url ?? undefined,
  featured: b.featured,
  readUrl: b.read_url ?? undefined,
  ebookAffiliateLink: b.ebook_affiliate_link ?? null,
  physicalBookAffiliateLink: b.physical_book_affiliate_link ?? null,
  audiobookAffiliateLink: b.audiobook_affiliate_link ?? null,
  hasAudiobook: b.has_audiobook ?? false,
  subgenre: b.subgenre ?? [],
  representation: b.representation ?? [],
  representationCustom: b.representation_custom ?? null,
  seriesType: b.series_type ?? null,
  readingExperience: b.reading_experience ?? null,
  createdAt: b.created_at ?? null,
});

export const useBooks = () => {
  const [books, setBooks] = useState<Book[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    supabase
      .from("books")
      .select("*")
      .order("created_at", { ascending: false })
      .then(({ data, error }) => {
        if (!active) return;
        if (!error && data) setBooks((data as DbBook[]).map(mapBook));
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { books, loading };
};
